import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Import the CommonJS module using dynamic import
// This will be transformed by Vite during build
import { projectSelector } from "@rflocal/shared";

// Initialize Firebase with config from projectSelector
const config = projectSelector.firebaseConfig();
const app = initializeApp(config);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
